import downloadFile from "./../../../core/utilities/download-file";

export const downloadXerSoftware = () => {
  downloadFile("https://www.xertransfer.com/downloads/xt101/setup.exe");
};

export const isRegularOrCorporateUser = (type) => {
  return !(type && !(type === 1 || type === 2));
};
